
const services = [
  {
    icon: 'ri-headphone-line',
    title: 'Ear Piercings',
    description: 'From classic lobes to intricate cartilage work including helix, tragus, conch, daith, and rook piercings. We create stunning ear curations that complement your unique style. Each piercing includes premium jewelry options in surgical steel, titanium, or gold.'
  },
  {
    icon: 'ri-user-smile-line',
    title: 'Nose Piercings',
    description: 'Nostril, septum, bridge, and high nostril piercings performed with precision and care. We offer a wide selection of nose jewelry including studs, hoops, and specialty pieces. Our artists ensure proper placement for optimal healing and aesthetic appeal.'
  },
  {
    icon: 'ri-emotion-line',
    title: 'Face Piercings',
    description: 'Eyebrow, lip, labret, monroe, medusa, and cheek piercings. We specialize in facial anatomy and proper placement to enhance your features. All facial piercings include consultation on jewelry styles and comprehensive aftercare instructions.'
  },
  {
    icon: 'ri-body-scan-line',
    title: 'Body Piercings',
    description: 'Professional body piercing services including navel, nipple, surface piercings, and more intimate options. We maintain the highest safety standards with single-use needles and sterile environments. Each body piercing includes appropriate jewelry selection based on anatomy and lifestyle.'
  },
  {
    icon: 'ri-palette-line',
    title: 'Custom Piercings',
    description: 'Unique placement and specialty piercings tailored to your vision. Our artists work with you to create one-of-a-kind piercing arrangements that reflect your personal style. We assess anatomy and provide expert recommendations for custom projects.'
  },
  {
    icon: 'ri-star-line',
    title: 'Jewelry Upgrades',
    description: 'Extensive collection of premium jewelry for existing piercings. Choose from surgical steel, titanium, gold, and specialty pieces. We can help you upgrade your current jewelry or create a complete new look with our curated selection of high-quality options.'
  }
];

export default function Services() {
  return (
    <section id="services" className="py-24 bg-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Our Services
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Professional piercing services with jewelry included. All piercings performed by experienced artists in a clean, safe environment.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index} 
              className="bg-gray-900 p-8 rounded-xl hover:bg-gray-800 transition-all hover:shadow-2xl hover:shadow-red-600/20 border border-gray-800 hover:border-red-600/50"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-red-600 rounded-xl mb-6">
                <i className={`${service.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold text-white mb-3">
                {service.title}
              </h3>
              <p className="text-gray-400 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gray-900 p-8 rounded-xl border border-gray-800">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div>
              <h3 className="text-2xl font-bold text-white mb-2">
                Walk-Ins Welcome
              </h3>
              <p className="text-gray-400">
                No appointment needed. Visit us at either of our two Wichita locations during business hours.
              </p>
            </div>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a 
                href="tel:3163057076"
                className="bg-red-600 text-white px-8 py-4 rounded-lg hover:bg-red-700 transition-all font-bold text-lg cursor-pointer whitespace-nowrap shadow-lg hover:shadow-xl transform hover:scale-105 text-center inline-block"
              >
                Call Justin
              </a>
              <a 
                href="tel:3168807760"
                className="bg-red-600 text-white px-8 py-4 rounded-lg hover:bg-red-700 transition-all font-bold text-lg cursor-pointer whitespace-nowrap shadow-lg hover:shadow-xl transform hover:scale-105 text-center inline-block"
              >
                Call Tia
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}